module.exports = __webpack_public_path__ + "img/nlg.363ca413.svg";